
export default {

    data() {
        return {
            axios: window.axios,
            meta: null,
            pagination: null,
            per_page: 10,
            page: 1
        };
    },
    methods: {

        //IMPORTANT update the router before loadDate! loadData will fetch from the url params

        //chages the curent page and reload the data 
        //trigered when user changes the page
        paginationChange(page) {
            this.page = page;

            //save the prev. data 
            let q = {}
            for (const [key, value] of Object.entries(this.$router.currentRoute.query)) {
                q[key] = value;
            }

            q.page = page;

            this.$router.push({ path: this.$route.path, query: q });

            this.loadData();
        },

        //change number of records per page
        changePerPage(val) {

            //save the prev. data 
            let q = {}
            for (const [key, value] of Object.entries(this.$router.currentRoute.query)) {
                q[key] = value;
            }

            q.per_page = val;
            q.page = 1;

            this.$router.push({ path: this.$route.path, query: q });
            this.loadData();
        }
    }

}
